/** Single source of truth for "is the user logged in?". */

import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/lib/authApi";

export const AUTH_KEY = ["auth", "me"] as const;

interface UseAuthResult {
  user: string | null;
  loading: boolean;
}

export function useAuth(): UseAuthResult {
  const { data, isPending } = useQuery({
    queryKey: AUTH_KEY,
    queryFn: () => authApi.me(),
    // Long stale time — /api/auth/me changes only on login/logout, both of
    // which already invalidate this key explicitly.
    staleTime: 60_000,
    retry: false,
  });
  return { user: data?.user ?? null, loading: isPending };
}
